import { render, staticRenderFns } from "./browse-history.vue?vue&type=template&id=ae4cb3ae&scoped=true"
import script from "./browse-history.vue?vue&type=script&lang=js"
export * from "./browse-history.vue?vue&type=script&lang=js"
import style0 from "./browse-history.vue?vue&type=style&index=0&id=ae4cb3ae&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/user/browse-history.less?vue&type=style&index=1&id=ae4cb3ae&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4cb3ae",
  null
  
)

export default component.exports